import React, { useState, useEffect } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  useUploadBuyerDetailsMutation,
  useGetCommoditiesAllDataQuery,
  useGetQualityParameterQuery,
  useGetCommoditiesDataQuery,useGetAddressInfoListQuery,usePostAddressSellandBuyMutation
} from "./ProcurementApiSlice";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField ,Typography} from "@mui/material";
import Button from "@mui/material/Button";
import InputAdornment from "@mui/material/InputAdornment";
import { useSelector } from "react-redux";
import { selectCurrentRoles } from "features/auth/authSlice";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";
import Tooltip from "@mui/material/Tooltip";
import "react-dropdown-tree-select/dist/styles.css";
import Avatar from '@mui/material/Avatar';
import AddIcon from '@mui/icons-material/Add';
import { green } from '@mui/material/colors';
import {  Modal } from 'antd';
import { Button as AntButton ,ConfigProvider} from 'antd';
import { Divider, Flex, Tag } from 'antd';
import AgricultureIcon from "@mui/icons-material/Agriculture";
import CategoryIcon from "@mui/icons-material/Category";
import EventIcon from "@mui/icons-material/Event";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ScaleIcon from "@mui/icons-material/Scale";
import BalanceIcon from "@mui/icons-material/Balance";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ScheduleIcon from '@mui/icons-material/Schedule';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { CardContent ,Grid,Card} from "@mui/material";

const CreateBuy = ({ refetch, user_id,UserData,setInitiateTradeShow,setValue }) => {
  // const { data: getCommodity } = useGetCommoditiesAllDataQuery();
  // const { data: getCommodity } = useGetCommoditiesDataQuery({
  //   user_id: user_id
  // });
  const { data: getCommodity } = useGetCommoditiesDataQuery(
    { user_id: user_id }, // Query parameters
    {
      refetchOnMountOrArgChange: true // Options
    }
  );

  const [createAggregation] = useUploadBuyerDetailsMutation();
  const RolesFromToken = useSelector(selectCurrentRoles);
  const [CommodityData, setCommodityData] = useState([]);
  const [addStockData, setAddedStock] = useState({
    crop_name: "",
    price: "",
    quantity: "",
    location: {},
    address: "",
    variety: "",
    season: "",
    year: "",
    quoted_type: "",
    bag_type: "",
    weight_type: "",
    bag_weight: "",
    weigth_tolerance: "",
    bag_weight_unit: "",
    type_of_sale: "",
  });
  const Season = [
    { title: "Rabi", year: 1990 },
    { title: "Kharif", year: 1991 },
    { title: "Zaid", year: 1992 },
  ];
  const Year = [
    { title: 2025, year: 1989 },

    { title: 2024, year: 1990 },
    { title: 2023, year: 1991 },
    { title: 2022, year: 1991 },
    { title: 2021, year: 1992 },
    { title: 2020, year: 1993 },
  ];
  const PriceQuoted = [
    { title: "Warehouse", year: 1990 },
    { title: "TruckLoad", year: 1991 },
  ];
  const [cropIdSelected, setCropIdSelected] = useState("");
  const { data: qualityRanges } = useGetQualityParameterQuery(cropIdSelected);
  const { data: getAddress,refetch:refetchAddress } = useGetAddressInfoListQuery({type:"buyer",UserData:UserData});
  const [postAddressSeller,] = usePostAddressSellandBuyMutation();
  const [QualityRanges, setQualityRanges] = useState([]);
  const [loading, setloading] = useState(false);
  const [PincodeDataList, setPincodeDataList] = useState({
    State: "",
    District: "",
    Block: "",
  });
  const [pincodeError, setPinCodeError] = useState(false);
  const [PincodeValue, setPincode] = useState("");
  const [showError, setError] = useState(false);
  const [addressList, setaddressList] = useState([])
  const [othersValue, setOthersValue] = useState("");
  const [editedValues, setEditedValues] = useState({}); 

  const Unit = [
    // { title: "Metric Tonne", year: 1990 },
    { title: "Quintal", year: 1991 },
  ];
  const BagType = [
    { title: "Jute", year: 1990 },
    { title: "PP", year: 1991 },
  ];
  const BagWeight = [
    { title: "Net", year: 1990 },
    { title: "Gross", year: 1991 },
  ];
  const WeightUnit = [
    { title: "KG", year: 1990 },
    { title: "Gram", year: 1991 },
  ];
  
  const PaymentType = [
    { title: "D+", year: 1990 },
    { title: "Advance", year: 1991 },
    { title: "Loading", year: 1992 },
    { title: "D-Delivery", year: 1991 },

  ];
  const [treeData, setTreeData] = useState([]);
  const [stateResponse, setStateResponse] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  useEffect(() => {
    if (qualityRanges?.data) {
      setQualityRanges(qualityRanges?.data);
      if (cropIdSelected) {
        setTreeData(qualityRanges?.data);
        setSelectedFields([]);
      } else {
        setTreeData([]);
        setSelectedFields([]);
      }
    }
  }, [qualityRanges]);
  useEffect(() => {
    if (getCommodity) {
      setCommodityData(getCommodity?.data);
    }
  }, [getCommodity]);
  useEffect(()=>{
    if(getAddress)
      setaddressList(getAddress?.data)
  },[getAddress])
  const handleSubmit = (e) => {
    e.preventDefault();
    setloading(true);
    const response = selectedFields?.map((field) => {
      return {
        range: field.range,
        fields: field.fields,
      };
    });
    let payload = {
      ...addStockData,
      created_by: RolesFromToken.organization_id,
      StateName: selectedAddress.state,
      DistrictName: selectedAddress.city,
      BlockName: selectedAddress.address_line2,
      erp_address_reference:selectedAddress?.name,
      address:selectedAddress.address_line1,
      pincode:selectedAddress.pincode,
      created_for: "",
      is_initial_relationship: false,
      entity_type: "Buyer",
      crop_code: cropIdSelected,
      unit_of_measure: addStockData.unit_measurement,
      type_of_sale: addStockData.type_of_sale,
     
      delivery_and_payment_detail: {
        delivery_timeline: addStockData.delivery_timeline,
        payment_timeline: addStockData.payment_timeline,
        payment_type: addStockData.payment_type,
      },
      quality_parameters: { "parameters": stateResponse.length > 0 ? stateResponse : [] },
      price_quoted_at: 0.1,
    };

    createAggregation(payload)
      .unwrap()
      .then(async(data) => {
        toast.success("Trade Initiated Successfully. Wait for Admin Approval !!");
        setAddedStock({
          price: "",
          quantity: "",
          entity_type: "Buyer",
          location: {},
          address: "",
          crop_name: "",
          variety: "",
          season: "",
          year: "",
          quoted_type: "",
          bag_type: "",
          weight_type: "",
          bag_weight: "",
          weigth_tolerance: "",
          bag_weight_unit: "",
          delivery_timeline: "",
          payment_timeline: "",
          type_of_sale: "",unit_measurement:"",payment_type:""
        });
        setPincode("");
        setPincodeDataList({
          State: "",
          District: "",
          Block: "",
        });
        await refetch();

        setloading(false);
        setCropIdSelected("");
        setError(false);
        setTreeData([]);
        setStateResponse([]);
        setSelectedFields([]);
        setSelectedAddress("")
        setOthersValue("");
        setInitiateTradeShow(false)
        setValue("selfInitiated")
        // setSelectedRanges([]);
        // setSelectedData([]);

      })
      .catch((error) => {
        toast.error(error?.data?.message);
        setloading(false);

        return;
      });
  };
  const handleChangePin = (name) => (e, value) => {
    setPincodeDataList({
      ...PincodeDataList,
      [e.target.name]: e.target.value,
    });
  };
  const handleChange = (name) => (e, value) => {
    if (
      name === "crop_name" ||
      name === "unit_measurement" ||
      name === "season" ||
      name === "year" ||
      name === "quoted_type" ||
      name === "bag_type" ||
      name === "weight_type" ||
      name === "bag_weight_unit" ||
      name === "payment_type"
    ) {
      setAddedStock({
        ...addStockData,
        [name]: value,
      });
    } else {
      setAddedStock({
        ...addStockData,
        [e.target.name]: e.target.value,
      });
    }

    if (name === "crop_name") {
      const filteredData = CommodityData?.find((item) => item.name === value);
      setCropIdSelected(filteredData?.code);
      // setCropCode(filteredData.crop_id)
    }
  };

  const handlePinCodeChange = (e) => {
    const newPinCode = e.target.value;
    if (newPinCode.length <= 6) {
      setPincode(newPinCode);
    }
  };
  useEffect(() => {
    const apiUrl = `https://api.postalpincode.in/pincode/${PincodeValue}`;

    fetch(apiUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data[0].Status === "Success") {
          setPincodeDataList(data[0].PostOffice[0]);
          setPinCodeError(false);
        }
        if (data[0].Status === "Error") {
          setPinCodeError(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [PincodeValue]);
 const handleCheckboxChange = (item) => {
  if (item === "Others") {
    setSelectedFields((prevFields) => {
      const othersIndex = prevFields.findIndex((field) => field.fields === "Others");

      if (othersIndex !== -1) {
        return prevFields.filter((field) => field.fields !== "Others");
      } else {
        return [
          ...prevFields,
          { fields: "Others", range: { range_one: "", edited_key: "" } }
        ];
      }
    });
  } else {
    setSelectedFields((prevFields) => {
      const isSelected = prevFields.some((field) => field.fields === item.fields);
      if (isSelected) {
        return prevFields.filter((field) => field.fields !== item.fields);
      } else {
        return [...prevFields, item];
      }
    });
  }
};

const handleRadioChange = (field, rangeKey) => {
  setEditedValues((prev) => ({
    ...prev,
    [field]: { 
      ...prev[field], 
      selectedRange: rangeKey 
    },
  }));
};

const handleInputChange = (field, rangeKey, newValue) => {
  setEditedValues((prev) => ({
    ...prev,
    [field]: { 
      ...prev[field], 
      [rangeKey]: newValue
    },
  }));
};


  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  useEffect(() => {
    const response = selectedFields.map((field) => {
      const fieldName = field.fields;
  
      const treeDataField = treeData.find((item) => item.fields === fieldName);
  
      const editedField = editedValues[fieldName] || {};
  
      const range = {};
      const selectedKey = editedField.selectedRange || treeDataField?.selected_key || ""; 
  
      if (fieldName === "Others") {
        range["range_one"] = editedField["range_one"] || treeDataField?.range?.range_one || ""; 
        range["edited_key"] = editedField["edited_key"] || ""; 
      } else {
        if (selectedKey && treeDataField[selectedKey]) {
          range[selectedKey] = treeDataField[selectedKey]; 
        }
        range["edited_key"] = editedField[selectedKey] || ""; 
      }
  
      return {
        fields: fieldName,
        range,
      };
    });
  
    setStateResponse(response);
  }, [selectedFields, editedValues, treeData]);
  
  const handleClose = () => {
    setIsModalOpen(false);
  };
  const handleAddressAdd = () => {
    setIsModalOpen(true)
  };
  
  const postAddress=()=>{
    let data ={
      "address_line1": addStockData.address,
      "address_line2": PincodeDataList?.Block,
      city:PincodeDataList?.District,
      state: PincodeDataList?.State,
      "country": "India",
      "pincode": PincodeValue,
      "email_id": "",
      "phone": "",
      "fax": "",
      "gstin": "",
      "gst_state": "",
      "links": [
          {
              "link_doctype": "Customer",
              "link_name": UserData
          }
      ]
  }
  postAddressSeller(data)
  .unwrap()
  .then((data) => {
    refetchAddress()
    setPincode("")
    setPincodeDataList({       
     State:"",
     District:"",
     Block:""
   }) 
   setIsModalOpen(false)
  //  setAddedStock({
  //   address: "",
  // });
  })
  .catch((error) => {
    return
  })
  }
  const[selectedAddress,setSelectedAddress]=useState("")

  const handleSelectedAddress=(event, newValue)=>{setSelectedAddress(newValue)}
  const handleOthersInputChange = (e) => {
    const value = e.target.value;
  
    setOthersValue(value); // Update the local value
  
    // Update the editedValues to store the value for "Others"
    setEditedValues((prevEditedValues) => ({
      ...prevEditedValues,
      Others: {
        ...prevEditedValues.Others,
        range_one: value, // Update range_one for "Others"
      },
    }));
  
    // If you want to update selectedFields as well (to ensure it's tracked when "Others" is selected)
    const existingIndex = selectedFields.findIndex((f) => f.fields === "Others");
  
    if (existingIndex !== -1) {
      setSelectedFields((prevFields) => {
        const updatedFields = [...prevFields];
        updatedFields[existingIndex] = { fields: "Others", range: { range_one: value, edited_key: "" } };
        return updatedFields;
      });
    }
  };
  

  return (
    <div className="">
        <div className="">
          <h3 className="text-gray text-center mt-1 text-black">
            Initiate Trade
          </h3>
          <i className="text-warning text-center mt-2">
  Complete the form below to start your trade for the chosen commodity.
</i>
          <div className="mt-2 w-full max-w-lg mx-auto" style={{width:"80%",margin:"auto"}} >
          <Card
              variant="outlined"
              sx={{
                padding: { xs: 0, sm: 0, md: 2, lg: 2},
                borderRadius: "12px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                transition: "transform 0.3s",
                // "&:hover": { transform: "scale(1.02)" },
              }}
            >
             
          <form onSubmit={handleSubmit} className="form-submit mb-2 mt-3 p-0 p-lg-2">
            <div className="row">
              <div className="col-lg-4 ">
                <Autocomplete
                  
                  id="free-solo-2-demo"
                  name="crop_name"
                  disableClearable
                  options={CommodityData?.map((option) => option.name)}
                  onChange={handleChange("crop_name")}
                  value={addStockData?.crop_name}
                  className="mx-1 mt-2 mt-lg-0"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Commodity"
                      InputLabelProps={{ shrink: true }} 
                      required
                      InputProps={{
                        ...params.InputProps,
                        type: "search",
                        endAdornment: (
                          <>
                            {params.InputProps.endAdornment}
                            <ArrowDropDownIcon />
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </div>
              <div className="col-lg-3  mt-3 mt-lg-0 ">
                <TextField
                  id="outlined-multiline-flexible"
                  type="text"
                  label="Variety"
                  name="variety"
                  value={addStockData.variety}
                  required
                  className=""
                  onChange={handleChange("variety")}
                  multiline
                  maxRows={2}
                  style={{ width: "100%" }}
                  InputLabelProps={{ shrink: true }} 
                />
              </div>
              <div className="col-lg-3  mt-3 mt-lg-0">
                <Autocomplete
                  
                  id="free-solo-2-demo"
                  name="season"
                  className=""
                  disableClearable
                  value={addStockData.season}
                  onChange={handleChange("season")}
                  options={Season?.map((option) => option.title)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Season"
                      InputLabelProps={{ shrink: true }}
                      required
                      InputProps={{
                        ...params.InputProps,
                        type: "search",
                       
                        startAdornment: (
                          <InputAdornment position="start">
                            <CalendarMonthIcon style={{ color: "#6c757d" }} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </div>
              <div className="col-lg-2 mt-3 mt-lg-0 ">
                <Autocomplete
                  
                  id="free-solo-2-demo"
                  name="year"
                  className=""
                  disableClearable
                  value={addStockData.year}
                  onChange={handleChange("year")}
                  options={Year?.map((option) => option.title)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Year"
                      InputLabelProps={{ shrink: true }}
                      required
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <InputAdornment position="start">
                            <EventIcon style={{ color: "#6c757d" }} />
                          </InputAdornment>
                        ),
                        type: "search",

                      
                      }}
                    />
                  )}
                />
              </div>
             
              <div className="col-lg-3  ">
                <TextField
                  id="outlined-multiline-flexible"
                  label="Quantity"
                  name="quantity"
                  required
                  multiline
                  value={addStockData?.quantity}
                  maxRows={2}
                  onChange={handleChange("quantity")}
                  onKeyPress={(event) => { 
                    if (!/\d/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  style={{ width: "100%" }}
                  InputLabelProps={{ shrink: true }} 
                  className="mx-1 mt-4"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end"></InputAdornment>
                    ),
                    startAdornment: (
                      <InputAdornment position="start">
                        <ScaleIcon style={{ color: "#6c757d" }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="col-lg-3 ">
                <Autocomplete
                  
                  id="free-solo-2-demo"
                  name="unit_measurement"
                  value={addStockData?.unit_measurement}
                  className="mt-4"
                  disableClearable
                  onChange={handleChange("unit_measurement")}
                  options={Unit?.map((option) => option.title)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Unit"
                      InputLabelProps={{ shrink: true }} 
                      required
                      InputProps={{
                        ...params.InputProps,
                        type: "search",
                       
                        startAdornment: (
                          <InputAdornment position="start">
                            <BalanceIcon style={{ color: "#6c757d" }} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </div>
              <div className="col-lg-3 ">
                <TextField
                  id="outlined-multiline-flexible"
                  label="Price/ Unit(₹)"
                  name="price"
                  value={addStockData?.price}
                  onChange={handleChange("price")}
                  required
                  className="mt-4"
                  onKeyPress={(event) => { 
                    if (!/\d/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  multiline
                  maxRows={2}
                  style={{ width: "100%" }}
                  InputLabelProps={{ shrink: true }} 
                />
              </div>
              {addStockData.quantity && addStockData.price ? (
                <h6
                  className=" mt-2 text-successs mx-2"
                  style={{ fontSize: "10px" }}
                >
                  {" "}
                  Total Price : ₹{addStockData.quantity * addStockData.price}
                </h6>
              ) : (
                ""
              )}
               <div className="col-lg-5 col-12 mt-3 ">
                <h6 className=" mt-2 text-gray mx-2">
                  Choose Quality Parameters :{" "}
                </h6>
                <div
                  className="dropdown-nested text-center cursor-pointer mt-2"
                  onClick={handleDropdownToggle}
                  style={{ width: "98%" }}
                >
                  {" "}
                  Select Parameters <ArrowDropDownIcon className="f400" />
                </div>
                
                </div>

             

    <div>
      < div className={`dropdown-menu dropdown-nested ${
    isDropdownOpen ? "show" : ""
  }`}
        style={{
          width: "53%",
          zIndex: "100",
          backgroundColor: "white",
          boxShadow: "0px 0px 11px 3px rgba(0, 0, 0, 0.2)",
        }}
      >
        {treeData?.map((item) => (
          <div key={item.fields} className="item-nested mx-3 p-2">
            <input
              type="checkbox"
              checked={selectedFields.some((field) => field.fields === item.fields)}
              onChange={() => handleCheckboxChange(item)}
            />
            <span className="mx-2">{item.fields}</span>
            {selectedFields?.some((field) => field.fields === item.fields) && (
              <div className="mx-3 mt-2">
                <h6>Values:</h6>
                <div className="ranges">
                  {Object.entries(item)
                    .filter(([key]) => key.startsWith("range_")) 
                    .map(([rangeKey, rangeValue]) => (
                      <div key={rangeKey} className="range-item">
                        <input
                          type="radio"
                          name={item.fields}
                          value={rangeValue}
                          checked={
                            editedValues[item.fields]?.selectedRange === rangeKey
                          }
                          onChange={() => handleRadioChange(item.fields, rangeKey)}
                        />
                        <input
                          type="text"
                          disabled={
                            editedValues[item.fields]?.selectedRange !== rangeKey
                          }
                          defaultValue={
                            editedValues[item.fields]?.[rangeKey] || rangeValue
                          }
                          onChange={(e) =>
                            handleInputChange(
                              item.fields,
                              rangeKey,
                              e.target.value
                            )
                          }
                          style={{width:"40%",padding:"2px"}}

                        />
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
        ))}
          <div className="mx-4">
  <input
    type="checkbox"
    checked={selectedFields?.some((field) => field.fields === "Others")}
    onChange={() => handleCheckboxChange("Others")}
  />
  <label className="mx-1">Others</label>
  {selectedFields.some((field) => field.fields === "Others") && (
    <TextField
      id="outlined-multiline-flexible"
      name="Others"
      value={othersValue}
      onChange={handleOthersInputChange}
      required
      className="mt-5 mx-1"
      size="small"
      style={{ width: "40%" }}
      InputLabelProps={{ shrink: true }} 
    />
  )}
</div>
      
    </div>


    {stateResponse?.length > 0 && (
                  <div className="flex-grow-1 text-right parametersClass">
                   <ul className="">
  {stateResponse?.map((field, index) => (
    <li key={index}>
      {field.fields},
      {field?.range && Object.keys(field?.range).length > 0 && (
        <span className="mx-2">
          {field.range.edited_key !== ""
            ? field.range.edited_key
            : field.range.range_two || field.range.range_one || field.range.range_three || ""}
        </span>
      )}
    </li>
  ))}
</ul>

                  </div>
                )}
              </div>
              <div className="col-lg-3 ">
                <Autocomplete
                  
                  id="free-solo-2-demo"
                  name="weight_type"
                  className="mt-4"
                  disableClearable
                  value={addStockData.weight_type}
                  onChange={handleChange("weight_type")}
                  options={BagWeight?.map((option) => option.title)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Weight Type"
                      InputLabelProps={{ shrink: true }}
                      required
                      InputProps={{
                        ...params.InputProps,
                        type: "search",
                       
                      }}
                    />
                  )}
                />
              </div>
              <div className="col-lg-3 ">
                <Autocomplete
                  
                  id="free-solo-2-demo"
                  name="bag_type"
                  className="mt-4"
                  disableClearable
                  value={addStockData.bag_type}
                  onChange={handleChange("bag_type")}
                  options={BagType?.map((option) => option.title)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Bag Type"
                      InputLabelProps={{ shrink: true }}
                      required
                      InputProps={{
                        ...params.InputProps,
                        type: "search",
                       
                      }}
                    />
                  )}
                />
              </div>
            
              {addStockData.weight_type == "Net" && (
                <>
                  <div className="col-lg-3 ">
                    <TextField
                      id="outlined-multiline-flexible"
                      label="Bag Weight"
                      name="bag_weight"
                      onChange={handleChange("bag_weight")}
                      value={addStockData.bag_weight}
                      required
                      className="mt-4"
                      multiline
                      maxRows={2}
                      style={{ width: "100%", zIndex: 0 }}
                      InputLabelProps={{ shrink: true }} 
                    />
                  </div>
                  <div className="col-lg-3 ">
                    <Autocomplete
                      freeSolo
                      id="free-solo-2-demo"
                      name="bag_weight_unit"
                      className="mt-4"
                      disableClearable
                      value={addStockData.bag_weight_unit}
                      onChange={handleChange("bag_weight_unit")}
                      options={WeightUnit?.map((option) => option.title)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Weight Unit"
                          InputLabelProps={{ shrink: true }}
                          required
                          InputProps={{
                            ...params.InputProps,
                            type: "search",
                           
                          }}
                        />
                      )}
                    />
                  </div>
                </>
              )}
              <div className="col-lg-3 ">
                <TextField
                  id="outlined-multiline-flexible"
                  label="Weight Tolerance (-5 to +5)"
                  name="weigth_tolerance"
                  value={addStockData.weigth_tolerance}
                  required
                  className="mt-4"
                  multiline
                  maxRows={2}
                  style={{ width: "100%", zIndex: 0 }}
                  InputLabelProps={{ shrink: true }} 
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const parsedValue = parseFloat(inputValue);
                    if (
                      inputValue === "" ||
                      inputValue === "-" ||
                      (!isNaN(parsedValue) &&
                        parsedValue >= -5 &&
                        parsedValue <= 5)
                    ) {
                      handleChange("weigth_tolerance")(e);
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
              </div>
              <div className="col-lg-3 ">
                <Autocomplete
                  id="free-solo-2-demo"
                  name="quoted_type"
                  className="mt-4"
                  disableClearable
                  value={addStockData.quoted_type}
                  onChange={handleChange("quoted_type")}
                  options={PriceQuoted?.map((option) => option.title)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Price Estimated For"
                      InputLabelProps={{ shrink: true }}
                      required
                      InputProps={{
                        ...params.InputProps,
                        type: "search",
                      
                      }}
                    />
                  )}
                />
              </div>
            
              <h6 className=" mt-3 text-gray mx-2 mb-2" style={{display:"flex",justifyContent: "flexStart"}}><LocationOnIcon/> Delivery Location : </h6>

              <div className='col-lg-4 '>
                       <Autocomplete
                        freeSolo
                       id="address-autocomplete"
                      className="mt-3"
                      disableClearable
                      options={addressList || []}
                     getOptionLabel={(option) => `${option.address_line1} ${option.city} ${option.state} ${option.pincode}`}
                     onChange={handleSelectedAddress}
                      name="Fulladdress"
                  renderInput={(params) => (
                     <TextField
                   {...params}
                  label="Select Address"
                  InputLabelProps={{ shrink: true }}
                    required
                 InputProps={{
                 ...params.InputProps,
                  type: 'search',
                
                      }}
                        />
                       )}
                       />
                     </div>
                                    <Tooltip title="Add Address">
                                    <Avatar sx={{ bgcolor: green[500] }} className='mt-4 cursor-pointer'>
                                     <AddIcon  
                                     onClick={handleAddressAdd}/>
                               </Avatar>
                                </Tooltip>
            
              <div className="col-lg-3 offset-md-1">
                <Tooltip
                  title="Note: Delivery Timeline is : Date of Trade + Number of days entered by User"
                  placement="top">
                  <TextField

                    label="Delivery Time (Days)"
                    name="delivery_timeline"
                    onChange={handleChange("delivery_timeline")}
                    value={addStockData.delivery_timeline}
                    required
                    className="mt-3"
                    multiline
                    maxRows={2}
                    style={{ width: "100%", zIndex: 0 }}
                    InputLabelProps={{ shrink: true }} 
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <ScheduleIcon style={{ color: "#6c757d" }} />
                        </InputAdornment>
                      ),
                      }}
                  />
                </Tooltip>
              </div>
              <div className="col-lg-3">
                                            <Autocomplete
                                              
                                              id="payment_type"
                                              name="payment_type"
                                              disableClearable
                                              value={addStockData.payment_type}
                                              className="mt-3"
                                              onChange={handleChange(
                                                "payment_type"
                                              )}
                                              options={PaymentType?.map(
                                                (option) => option.title
                                              )}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  label="payment Type"
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  required
                                                  InputProps={{
                                                    ...params.InputProps,
                                                    type: "search",
                                                   
                                                    startAdornment: (
                                                      <InputAdornment position="start">
                                                        <AttachMoneyIcon style={{ color: "#6c757d" }} />
                                                      </InputAdornment>
                                                    ),
                                                    
                                                  }}
                                                />
                                              )}
                                            />
                                          </div>
                                          {addStockData.payment_type ===
                                          "D+" ? (
                                            <div className="col-lg-4 mt-1">
                                              <Tooltip
                                                title="Note: Payment Timeline is : Date of Delivery + Number of days entered by User"
                                                placement="top"
                                              >
                                                <TextField
                                                  id="outlined-multiline-flexible"
                                                  label="Payment Time (Days)"
                                                  name="payment_timeline"
                                                  onChange={handleChange(
                                                    "payment_timeline"
                                                  )}
                                                  value={
                                                    addStockData.payment_timeline
                                                  }
                                                  required
                                                  className="mt-3"
                                                  multiline
                                                  maxRows={2}
                                                  style={{
                                                    width: "100%",
                                                    zIndex: 0,
                                                  }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }} 
                                                  InputProps={{
                                                    startAdornment: (
                                                      <InputAdornment position="start">
                                                        <ScheduleIcon style={{ color: "#6c757d" }} />
                                                      </InputAdornment>
                                                    ),
                                                    }}
                                                />
                                              </Tooltip>
                                            </div>
                                          ) : (
                                            ""
                                          )}
            
            </div>
           
                               <Divider orientation="right">
                                   <Button
                                   variant="contained"
                                   className="text-center"
                                   color="success"
                                   size="small"
                                   type="submit">
                                   Submit &nbsp;{" "}
                                   {loading ? <Spinner size="sm" /> : ""}
                                 </Button>
                                      </Divider>

          </form>
          </Card>
          </div>

          <Modal
        title="Add Address"
        open={isModalOpen}
        onCancel={handleClose}
        footer={[
         <AntButton type="primary" className="mt-2" onClick={postAddress} >
         Submit
       </AntButton>,
          <AntButton type="primary" danger onClick={handleClose} className="mt-2">
            Cancel
          </AntButton>,
         
        ]}
      >
        <div className="row">
        <Col lg="4" className="MuiTextArea2 mt-2">
                <TextField
                  id="outlined-multiline-flexible"
                  label="Pincode"
                  name="pincode"
                  value={PincodeValue}
                  onChange={handlePinCodeChange}
                  maxLength="6"
                  required
                  className="mt-1"
                  maxRows={2}
                  style={{ width: "100%" }}
                  InputLabelProps={{ shrink: true }} 
                />

                {PincodeValue.length > 6 ||
                  (pincodeError && (
                    <div style={{ color: "red" }}>Enter a valid pincode</div>
                  ))}
              </Col>
              <div className="col-lg-8 MuiTextArea2">
                <TextField
                  id="outlined-multiline-flexible"
                  label="State"
                  name="State"
                  onChange={handleChangePin("StateName")}
                  value={PincodeDataList?.State}
                  disabled
                  className="mt-2"
                  multiline
                  maxRows={2}
                  style={{ width: "100%", zIndex: 0 }}
                  InputLabelProps={{ shrink: true }} 
                />
              </div>
              <div className="col-lg-6 MuiTextArea2">
                <TextField
                  id="outlined-multiline-flexible"
                  label="District"
                  name="District"
                  onChange={handleChangePin("DistrictName")}
                  value={PincodeDataList?.District}
                  disabled
                  className="mt-2"
                  multiline
                  maxRows={2}
                  style={{ width: "100%", zIndex: 0 }}
                  InputLabelProps={{ shrink: true }} 
                />
              </div>{" "}
              <div className="col-lg-6 MuiTextArea2">
                <TextField
                  id="outlined-multiline-flexible"
                  label="Block"
                  name="Block"
                  onChange={handleChangePin("BlockName")}
                  value={PincodeDataList?.Block}
                  disabled
                  className="mt-2"
                  multiline
                  maxRows={2}
                  style={{ width: "100%", zIndex: 0 }}
                  InputLabelProps={{ shrink: true }} 
                />
              </div>
              <div className="col-lg-12 MuiTextArea2">
                <TextField
                  id="outlined-multiline-flexible"
                  label="Address"
                  name="address"
                  onChange={handleChange("address")}
                  value={addStockData.address}
                  required
                  className="mt-3"
                  multiline
                  maxRows={2}
                  style={{ width: "100%", zIndex: 0 }}
                  InputLabelProps={{ shrink: true }} 
                />
              </div>



        </div>

        
      </Modal>
        </div>
    </div>
  );
};

export default CreateBuy;
